module.exports = __webpack_public_path__ + "media/icons/map-marker-7e2fcda1.png";